import { Avatar, AvatarFallback, AvatarImage } from 'components/ui/avatar';
import defaultCaregiverPhoto from '../assets/experts-man-dark.png';

export type CaregiverAvatarProps = {
  avatar: string;
  name?: string;
  caption?: string;
};

const CaregiverAvatar: React.FC<CaregiverAvatarProps> = ({ avatar, name, caption }) => {
  return (
    <div className="[text-align-last:center]">
      <div>
        <div className="flex flex-col items-center">
          <Avatar className="size-12">
            <AvatarImage src={avatar || defaultCaregiverPhoto} alt="profile" />
            <AvatarFallback>{name?.[0]?.toUpperCase() ?? ''}</AvatarFallback>
          </Avatar>
        </div>
      </div>
      <div>
        <p className="m-0 overflow-hidden text-ellipsis whitespace-nowrap">{name}</p>
      </div>
      <p className="m-0 overflow-hidden text-ellipsis whitespace-nowrap text-2xs leading-none text-subtle-foreground">
        {caption}
      </p>
    </div>
  );
};
export default CaregiverAvatar;
